export const UNASSIGNED_TEAM_FILTER_ID = 'unassigned';
export const UNASSIGNED_TEAM_FILTER_TYPE = 'UnassignedTeam' as const;
